/**
 * 判断当前环境是否为同花顺客户端
 * @returns {boolean} 如果是同花顺客户端返回 true，否则返回 false
 * @example
 * ```ts
 * isInThsApp(); // => true (在同花顺客户端内)
 * isInThsApp(); // => false (在浏览器中)
 * ```
 */
export function isInThsApp(): boolean {
  if (typeof navigator === "undefined") {
    return false;
  }
  
  const ua = navigator.userAgent;
  return (/IHexin\/|Hexin_Gphone\//i.test(ua) && !/ifind/i.test(ua));
}
